module.exports = __webpack_public_path__ + "img/logo.bca428b1.jpg";